import { GoogleMap, Marker } from '@react-google-maps/api';
import React, { useState, useCallback, useEffect } from 'react';

import StationLocator from '../../../assets/icons/dashboard/station-locator.svg';
import { useGoogleMaps } from '../../../contexts/google-map-context/GoogleMapContent';
import BatteryLoader from '../../battery-loader/BatteryLoader';
import MyButton from '../../button/Button';

interface SelectLatLongProperties {
  latitude: string | number | null;
  longitude: string | number | null;
  handleLatLongChange: (latitude: number, longitude: number) => void;
}

const containerStyle = { width: '800px', height: '450px' }; // Map container style

/**
 * Select location entire popup with buttons
 */
function SelectLatLong({ latitude, longitude, handleLatLongChange }: SelectLatLongProperties) {
  const { isLoaded } = useGoogleMaps();

  const [selectedLocation, setSelectedLocation] = useState({
    lat: Number(latitude),
    lng: Number(longitude),
  });

  // Default center for the map
  const [mapCenter, setMapCenter] = useState({
    lat: 41.8781, // Example: San Francisco
    lng: -87.6298,
  });

  // Handle map click event to update the selected location
  const onMapClick = useCallback((event: google.maps.MapMouseEvent) => {
    if (event.latLng) {
      setSelectedLocation({
        lat: parseFloat(event.latLng.lat().toFixed(5)),
        lng: parseFloat(event.latLng.lng().toFixed(5)),
      });
    }
  }, []);

  useEffect(() => {
    if (latitude && longitude) {
      setMapCenter({
        lat: Number(latitude),
        lng: Number(longitude),
      });
    }
  }, []);

  if (!isLoaded)
    return (
      <div>
        <BatteryLoader />
      </div>
    );

  return (
    <div className="select-latLong-wrap">
      <div className="select-latLong-container">
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={mapCenter}
          zoom={17}
          onClick={onMapClick}>
          <Marker
            icon={{
              url: StationLocator,
              scaledSize: new window.google.maps.Size(44, 44), // Width, Height
            }}
            position={selectedLocation}
          />
        </GoogleMap>
      </div>
      <div className="select-latLong-buttons">
        <MyButton
          label="Submit"
          buttonType="submit"
          onClickFunc={() =>
            handleLatLongChange(Number(selectedLocation.lat), Number(selectedLocation.lng))
          }
        />
      </div>
    </div>
  );
}

export default SelectLatLong;
